import $ from "jquery";
window.$ = window.jQuery = $;

import "slick-carousel";

let Rellax = require('rellax');

jQuery(document).ready(function ($) {

	$('a[href^="#"]').on('click', function (event) {
		var target = $(this.getAttribute('href'));
		// var target = $(this).closest(".alignfull").nextAll(".wp-block-group");
		if (target.length) {
			event.preventDefault();
			$('html, body').stop().animate({
				scrollTop: target.offset().top - 100
			}, 1000);
		}
	});

	$('.hamburger').click(function () {
		$(this).toggleClass("active");
		$('body').toggleClass("menu-is-open");
	});

	$('.slider').slick({
		dots: true,
		arrows: false,
		infinite: true,
		speed: 300,
		slidesToShow: 1,
		adaptiveHeight: true,
		appendDots: $('.dots-container')
	});

	// var rellax = new Rellax('.img-text-wrap img');
	var rellax = new Rellax('.img-text-wrap img', {
		center:true,
		breakpoints:[540, 768, 960]
	  });
	
	headerScroll();
})



$(window).scroll(function () {
	headerScroll();
});

function headerScroll() {
	var $ = jQuery;

	scroll = $(window).scrollTop();

	if (scroll >= 30) {
		$("body").addClass("is-scrolled");
	} else {
		$("body").removeClass("is-scrolled");
	}
}